<template>
  <Select v-model="selected" @on-select="handleSelect" :clearable="clearable" :placeholder="$t('order.nsf_phase_select_placeholder')" :disabled="disabled">
    <OptionGroup :label="$t('nsf.engineering')">
      <Option value="S1" label="S1">
        <span style="float: left;">S1</span>
        <span style="float: right;">{{ $t('nsf.s1_desc') }}</span>
      </Option>
      <Option value="S2" label="S2">
        <span style="float: left;">S2</span>
        <span style="float: right;">{{ $t('nsf.s2_desc') }}</span>
      </Option>
    </OptionGroup>
    <OptionGroup :label="$t('nsf.npi')">
      <Option value="S3" label="S3">
        <span style="float: left;">S3</span>
        <span style="float: right;">{{ $t('nsf.s3_desc') }}</span>
      </Option>
    </OptionGroup>
    <OptionGroup :label="$t('nsf.productization')">
      <Option value="S4" label="S4">
        <span style="float: left;">S4</span>
        <span style="float: right;">{{ $t('nsf.s4_desc') }}</span>
      </Option>
      <Option value="S5" label="S5">
        <span style="float: left;">S5</span>
        <span style="float: right;">{{ $t('nsf.s5_desc') }}</span>
      </Option>
    </OptionGroup>
    <OptionGroup :label="$t('nsf.industrialization')">
      <Option value="S6" label="S6">
        <span style="float: left;">S6</span>
        <span style="float: right;">{{ $t('nsf.s6_desc') }}</span>
      </Option>
    </OptionGroup>
  </Select>
</template>

<script>
export default {
  name: 'NSFPhaseSelect',
  props: {
    clearable: Boolean,
    disabled: Boolean
  },
  data () {
    return {
      selected: this.$attrs.value
    }
  },
  methods: {
    handleSelect (item) {
      this.$emit('input', item.value)
    }
  },
  watch: {
    '$attrs.value' (val) {
      this.selected = val
    }
  }
}
</script>
